export const useRecaptcha = () => {
  const { $recaptcha } = useNuxtApp();

  const executeRecaptcha = async (action = 'submit') => {
    try {
      const token = await $recaptcha.getToken(action);
      return token;
    } catch (error) {
      console.error('reCAPTCHA error:', error);
      throw error;
    }
  };

  return {
    executeRecaptcha
  };
};
